import moment from 'moment';

export function generateRecurringDates(form) {
    const startDate = moment(form.selectedDate);
    const endDate = form.endDate ? moment(form.endDate) : null;
    const count = form.occurrences ? parseInt(form.occurrences) : null;
  
    const dates = [];
    let current = startDate.clone();
    let generated = 0;
  
    if (!form.recurrence || !form.frequency) {
      return [startDate.format('YYYY-MM-DD')];
    }
  
    while (
      (!endDate || current.isSameOrBefore(endDate, 'day')) &&
      (!count || generated < count)
    ) {
      const dayOfWeek = current.isoWeekday(); // 1 = lun, 7 = dim
      const dayStr = current.format('YYYY-MM-DD');
  
      if (form.frequency === 'hebdomadaire') {
        const selectedDays = form.selectedDays
          .map(d => parseInt(d))
          .filter(d => d >= 1 && d <= 5);
  
        if (selectedDays.includes(dayOfWeek)) {
          dates.push(dayStr);
          generated++;
        }
        current.add(1, 'day');
      }
  
      else if (form.frequency === 'journaliere') {
        if (dayOfWeek >= 1 && dayOfWeek <= 5) {
          dates.push(dayStr);
          generated++;
        }
        current.add(1, 'day');
      }
  
      else if (form.frequency === 'mensuelle') {
        if (dayOfWeek >= 1 && dayOfWeek <= 5) {
          dates.push(dayStr);
          generated++;
        }
        current.add(1, 'month');
      }
  
      else {
        break;
      }
    }
  
    return dates;
  }